<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pp_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pp_vendname">
            <label class="weui-form-preview__label">{{
              customLabel.pp_vendname || "供应商"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.pp_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="pp_buyername">
            <label class="weui-form-preview__label">{{
              customLabel.pp_buyername || "申请人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pp_buyername }}
              <call-mobile :em-id="form.main.pp_buyerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pp_amount">
            <label class="weui-form-preview__label">{{
              customLabel.pp_amount || "申请金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pp_amount, '¥#,##0.00')
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.pp_payamount"
            slot="pp_payamount"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pp_payamount || "已付金额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pp_payamount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pp_currency">
            <label class="weui-form-preview__label">{{
              customLabel.pp_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.pp_currency }}
              <span v-if="form.main.pp_rate && form.main.pp_rate != 1"
                >/ {{ form.main.pp_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pp_date">
            <label class="weui-form-preview__label">{{
              customLabel.pp_date || "申请日期"
            }}</label>
            <span class="weui-form-preview__value">{{
                dateFormat(form.main.pp_date, 'yyyy-MM-dd')
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pp_text1 || '自定义字段1'"
          v-model="form.main.pp_text1" slot="pp_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text2 || '自定义字段2'"
          v-model="form.main.pp_text2" slot="pp_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text3 || '自定义字段3'"
          v-model="form.main.pp_text3" slot="pp_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text4 || '自定义字段4'"
          v-model="form.main.pp_text4" slot="pp_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text5 || '自定义字段5'"
          v-model="form.main.pp_text5" slot="pp_text5" hidden="true" />
        </custom-layout>
      </div>

      <collapse v-if="form.items && form.items.length" class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ppd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ppd_slcode" v-if="form.main.pp_class == '付款申请'">
              <label class="weui-form-preview__label">{{
                customLabel.ppd_slcode || item.ppd_slkind || "来源单号"
              }}</label>
              <span class="weui-form-preview__value text-link" @click="showSource(item)"
                >{{ item.ppd_slcode }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="ppd_ordercode" v-if="form.main.pp_class == '预付款申请'">
              <label class="weui-form-preview__label">{{
                customLabel.ppd_ordercode || item.ppd_orderkind || "来源单号"
              }}</label>
              <span class="weui-form-preview__value text-link" @click="showSource(item)"
                >{{ item.ppd_ordercode }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="ppd_buyername" v-if="item.ppd_buyername">
              <label class="weui-form-preview__label">{{
                customLabel.ppd_buyername || "采购员"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.ppd_buyername
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ppd_amount">
              <label class="weui-form-preview__label">{{
                customLabel.ppd_amount || "单据金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.ppd_amount, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ppd_nowbalance">
              <label class="weui-form-preview__label">{{
                customLabel.ppd_nowbalance || "本次付款金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.ppd_nowbalance, "#,##0.00")
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.ppd_yamount"
              slot="ppd_yamount"
            >
              <label class="weui-form-preview__label">{{
                customLabel.ppd_yamount || "已支付金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.ppd_yamount, "#,##0.00")
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ppd_text1 || '自定义字段1'"
            v-model="item.ppd_text1" slot="ppd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text2 || '自定义字段2'"
            v-model="item.ppd_text2" slot="ppd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text3 || '自定义字段3'"
            v-model="item.ppd_text3" slot="ppd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text4 || '自定义字段4'"
            v-model="item.ppd_text4" slot="ppd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text5 || '自定义字段5'"
            v-model="item.ppd_text5" slot="ppd_text5" hidden="true" />
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.pp_receiver">
            <label class="weui-form-preview__label">收款单位</label>
            <span class="weui-form-preview__value">{{
              form.main.pp_receiver
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pp_bankinfo">
            <label class="weui-form-preview__label">收款银行</label>
            <span class="weui-form-preview__value">{{
              form.main.pp_bankinfo
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pp_bankcode">
            <label class="weui-form-preview__label">收款账号</label>
            <span class="weui-form-preview__value">{{
              form.main.pp_bankcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ve_payments">
            <label class="weui-form-preview__label">{{
              customLabel.ve_payments || "付款方式"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ve_payments
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pp_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.pp_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pp_maxpaydate">
            <label class="weui-form-preview__label">最晚应付日期</label>
            <span class="weui-form-preview__value">{{
                dateFormat(form.main.pp_maxpaydate, 'yyyy-MM-dd')
            }}</span>
          </div>
        </div>
      </div>

      <file-list v-model="form.main.pp_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";
import FileList from "@/components/FileList.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CallMobile,
    Collapse,
    CustomField,
    FileList
  },
  data() {
    return {
      baseUrl: "/api/money/payplease",
      caller: "PayPlease",
      xtype: "money-payplease-formpanel",
    };
  },
  methods: {
    /**
     * 跳转来源单据
     * 
     * @param {*} item 
     */
    showSource(item) {
      var kind = item.ppd_slkind || item.ppd_orderkind, id = item.sl_sourceid || item.ppd_orderid
      if (!kind || !id) {
        return;
      }
      var page = {
        '采购入库': '/purchase/in/',
        '外协入库': '/out_prod/in/',
        '采购单': '/purchase/order/',
        '外协工单': '/out_prod/make/'
      }[kind];
      if (page) {
        this.$router.push(page + id);
      }
    }
  }
};
</script>